import { Component, Input } from '@angular/core';
import {
  GridWidgetConfigService,
  WidgetType,
} from '../../../services/grid-widget-config.service';

@Component({
  selector: 'app-widget-arrange-placeholder',
  standalone: true,
  imports: [],
  templateUrl: './widget-arrange-placeholder.component.html',
  styleUrl: './widget-arrange-placeholder.component.scss',
})
export class WidgetArrangePlaceholderComponent {
  @Input() type!: string;
  @Input() headline?: string;
  @Input() showLabel = true;

  constructor(protected configService: GridWidgetConfigService) {}

  get display(): { icon: string; label: string } | undefined {
    return this.configService.getTypeDisplay(this.type as WidgetType);
  }
}
